import { Outlet, createRootRoute, useLocation } from "@tanstack/react-router";
import { notification } from "antd";
import { useEffect } from "react";
import * as React from "react";

import useUser from "/src/stores/useUser";
import { brand } from "/src/config/brand";
import { StorageKeys, getStorageItem } from "/src/services/storages/StorageKeys";

declare const window: any;

let GTMCallBackFor1stPage: any;

function send2GTM() {
  let dbCurrentUser = {} as any;

  try {
    dbCurrentUser = useUser.getState().user ?? JSON.parse(getStorageItem(StorageKeys.user) || "{}");
  } catch (e) {}

  // @ts-ignore
  if (dbCurrentUser?.user?.id) {
    let tagName = "gtm1";
    try {
      tagName = window.ga.getAll()[0].b.data.values[":name"];
    } catch (e) {
      // do nothing
    }
    window.ga(`${tagName}.set`, "userId", dbCurrentUser.user.id);
    window.ga(
      `${tagName}.set`,
      "dimension1",
      dbCurrentUser.user.name.endsWith(`@${brand.appEmailDomain}`),
    );
    window.ga(`${tagName}.send`, "pageview");
    if (GTMCallBackFor1stPage) {
      clearTimeout(GTMCallBackFor1stPage);
    }
  }
}

function send2GTMWithTimeout() {
  // @ts-ignore
  if (window.ga) {
    send2GTM();
  } else {
    GTMCallBackFor1stPage = setTimeout(() => {
      send2GTMWithTimeout();
    }, 200);
  }
}

export const Route = createRootRoute({
  component: RootComponent,
});

function RootComponent() {
  const location = useLocation();

  useEffect(() => {
    // clear all long alert
    notification.destroy();
    send2GTMWithTimeout();
  }, [location]);

  return (
    <React.Fragment>
      <Outlet />
    </React.Fragment>
  );
}
